// @flow

import '../style/global/_all.scss';
import '../components/Layout/index.scss';
import '../components/Topbar/index.scss';
import Header from './Header';
import Search from './Search';
import Bottom from './Bottom';
import CallButton from './CallButton';
import SearchSort from './SearchSort';
import AdFeatured from './AdFeatured';
import Medias from './Medias';
import Articles from './Articles';
import Reportages from './Reportages';
import AdShare from './AdShare';
import AdBookmark from './AdBookmark';

export default {
    'header': {
        permanent : true,
        component : Header
    },
    'search': {
        permanent : false,
        component : Search
    },
    'bottom': {
        permanent : true,
        component : Bottom
    },
    'call-button': {
        permanent : false,
        component : CallButton
    },
    'search-sort': {
        permanent : false,
        component : SearchSort
    },
    'ad-featured': {
        permanent : false,
        component : AdFeatured
    },
    'medias': {
        permanent : false,
        component : Medias
    },
    'articles': {
        permanent : false,
        component : Articles
    },
    'reportages': {
        permanent : false,
        component : Reportages
    },
    'ad-share': {
        permanent : false,
        component : AdShare
    },
    'ad-bookmark': {
        permanent : false,
        component : AdBookmark
    }
};
